import YandexEng from './YandexEng'

export default YandexEng
// eslint-disable-next-line import/export
export * from './YandexEng'
